<template>
  <div class="card mt-4">
      <div class="card-header pb-0 p-3">
        <div class="row">
          <div class="col-6 d-flex align-items-center">
            <h6 class="mb-0">{{ title }}</h6>
          </div>
        </div>
      </div>
      <div class="card-body p-3">
        <div class="row">
          <div class="col-md-6 mb-md-0 mb-4" v-for="(persona, index) in afiliados" :key="index">
            <a href="{{persona}}" download class="card card-body border card-plain border-radius-lg d-flex align-items-center flex-row mb-4">
              <img class="w-10 me-3 mb-0" src="@/assets/img/pdf_file_47.png" alt="Certificado de Afiliación" />
              <div class="d-block">
                <h6 class="mb-0">Certificado de Afiliación [{{ persona.codigo_certificado }}]</h6>
                <h6 class="mb-0">{{persona.nombres}} {{persona.apellidos}}</h6>
                <h6 class="text-sm">{{persona.documento}}</h6>
              </div>
              <i
                class="fas fa-cloud-download-alt fa-2x ms-auto text-dark cursor-pointer"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title = "Descargar Certificado"
                aria-hidden="true"
                data-bs-original-title="Descargar"
                aria-label="Descargar"
              ></i>
            </a>
          </div>
          <!-- <div class="col-md-6 mb-md-0 mb-4">
            <a href="{{certificado}}" download class="card card-body border card-plain border-radius-lg d-flex align-items-center flex-row">
              <img class="w-10 me-3 mb-0" src="@/assets/img/pdf_file_47.png" alt="Certificado de Afiliación" />
              <h6 class="mb-0">Certificado de Afiliación</h6>
              <i
                class="fas fa-cloud-download-alt fa-2x ms-auto text-dark cursor-pointer"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title = "Descargar Certificado"
                aria-hidden="true"
                data-bs-original-title="Descargar"
                aria-label="Descargar"
              ></i>
            </a>
          </div> -->
          <div class="col-md-6" v-if="this.factura!=''">
            <a href="{{factura}}" download
              class="card card-body border card-plain border-radius-lg d-flex align-items-center flex-row"
            >
              <img class="w-10 me-3 mb-0" src="@/assets/img/pdf_file_47.png" alt="Factura" />
              <h6 class="mb-0">Factura</h6>
              <i
                class="fas fa-cloud-download-alt fa-2x ms-auto text-dark cursor-pointer"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title
                aria-hidden="true"
                data-bs-original-title="Descargar Factura"
                aria-label="Descargar Factura"
              ></i>
            </a>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: "documentos-generados",
  props: {
    afiliados: {
      type: Array
    },
    certificado: {
      type: String,
      default: "#"
    },
    factura: {
      type: String,
      default: ""
    }
  },
  computed: {
    title() {
      return (this.factura == '') ? 'Documento Generado' : 'Documentos Generados'
    }
  }
};
</script>
